import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface ReportPayload {
  clientId?: string;
  packageId?: string;
  clientPackageMappingId?: string;
  functionalAreaId?: string;
  testTypeId?: string;
  scenarioId?: string;
  executionId?: string;
  tenantId?: string;
  numberOfSteps: number;
  status?:string;
  executionStatus?: string;
  passed: number;
  failed: number;
}

@Injectable({ providedIn: 'root' })
export class ReportApiService {
  private baseUrl = `${environment.apiUrl}/report`;

  constructor(private http: HttpClient) {}

  /** Override the API base URL at runtime (used by cloud/runner mode where apiBase differs from build-time env) */
  setApiBase(apiBase: string): void {
    const trimmed = (apiBase || '').replace(/\/$/, '');
    this.baseUrl = `${trimmed}/report`;
  }

  bulkSaveReports(reports: ReportPayload[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/bulksave`, reports);
  }
}
